import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col overflow-hidden w-full bg-white"
}
const _hoisted_2 = { class: "flex flex-row h-screen pb-4 overflow-y-auto" }
const _hoisted_3 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_6 = { class: "flex flex-row py-4" }
const _hoisted_7 = { class: "mt-4 bg-gray-lp-700 w-3/4" }
const _hoisted_8 = { class: "mt-4 bg-gray-lp-700 w-3/4" }
const _hoisted_9 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_10 = { class: "py-3" }
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-bold text-gray-lp-300 text-12px mb-2" }, " Tanggal Dibuat ", -1)
const _hoisted_13 = { class: "my-1 text-black-lp-300" }
const _hoisted_14 = { class: "text-gray-lp-500" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-bold text-gray-lp-300 text-12px mb-2" }, " Tanggal Diubah ", -1)
const _hoisted_16 = { class: "my-1 text-black-lp-300" }
const _hoisted_17 = { class: "text-gray-lp-500" }
const _hoisted_18 = { class: "py-4 flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_ctx.error)
    ? (_openBlock(), _createBlock(_component_ErrorMessage, {
        key: 0,
        errorType: _ctx.errorType,
        onTryAgain: _ctx.onTryAgain
      }, null, 8, ["errorType", "onTryAgain"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: "Config ID",
              class: "py-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Client Name",
              class: "py-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.accountRefName), 1)
              ]),
              _: 1
            }),
            _hoisted_4,
            _createVNode(_component_Title, {
              label: "Data Client Booking Template",
              class: "py-6 text-20px"
            }),
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, {
                label: "Header Client",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode("div", _hoisted_7, null, 512), [
                    [_directive_sanitize_html, _ctx.headerClient]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Header Genesis",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode("div", _hoisted_8, null, 512), [
                    [_directive_sanitize_html, _ctx.headerGenesis]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.createdAt), 1),
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.detailData.createdBy), 1)
              ]),
              _hoisted_15,
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.updatedAt), 1),
              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.detailData.updatedBy), 1)
            ]),
            _createVNode("div", _hoisted_18, [
              (_ctx.isEditAble)
                ? (_openBlock(), _createBlock(_component_lp_button, {
                    key: 0,
                    "custom-class": "px-8",
                    title: "Ubah",
                    "text-color": "white",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToEdit(_ctx.detailData)))
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
}